import { useAuth } from '@/contexts/AuthContext';
import { capitalSurfaceCaps, type Capability } from '@/lib/auth/capabilities';
import { getInvestorPortalCapabilities } from '@/lib/auth/investorPortalAuthority';
import { useInvestorPreview } from '@/hooks/useInvestorPreview';

/** Same preview and relationship authority for navigation, guards and preferences. */
export function useResolvedInvestorCapabilities(): Capability[] {
  const { user } = useAuth();
  const { isPreviewMode } = useInvestorPreview();
  const isAdminPreview = isPreviewMode && (
    user?.account_role === 'organization_admin' || user?.account_role === 'organization_owner'
  );
  return isAdminPreview ? [...capitalSurfaceCaps] : getInvestorPortalCapabilities(user);
}
